import initReactFastclick from './fastclick';
import injectScriptsFn from './inject-scripts';
import shimFn from './shim';
import initMockPassportAccount from './mock-passport-account';

export const fastclick = {
  enable: false,
  run: initReactFastclick
};

export const injectScripts = {
  enable: true,
  run: injectScriptsFn
};

export const shim = {
  enable: true,
  run: shimFn
};

export const mockPassportAccount = {
  enable: true,
  run: initMockPassportAccount
};
